/**
 * v-debounce 防抖
 */
export default {
    name: 'debounce',
    inserted: function (el, binding) {
        try {
            let fn,
                event = 'click',
                time = 500;
            if (typeof binding.value == 'function') {
                fn = binding.value;
            } else {
                [fn, event, time] = binding.value;
            }

            let timer;
            el.addEventListener(event, () => {
                timer && clearTimeout(timer);
                timer = setTimeout(() => fn(), time);
            });
        } catch (error) {
            console.log('防抖指令---error==>', error);
        }
    },
    unbind() {},
};
